import script from "./GroupMsgList.vue?vue&type=script&lang=ts&setup=true&name=GroupMsgList"
export * from "./GroupMsgList.vue?vue&type=script&lang=ts&setup=true&name=GroupMsgList"

import "./GroupMsgList.vue?vue&type=style&index=0&id=3491fc05&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3491fc05"]])

export default __exports__